<template>
  <section class="p-ipmonitor">
    <section class="c-visible-pc" v-if="$store.state.isPc">
      <section class="monitor-wrap">
        <section class="c-mt-84 monitor-title">
          <p class="c-fs-32 c-mb c-fw-b c-c-text-color-dark">IP地址管理&终端用户追踪系统</p>
          <p class="c-fs-16 c-mt-36 c-mb-56 c-lh-38 c-ta-j">随着人们对更高性能、BYOD、服务器虚拟化、云迁移以及智能设备的需求不断增加，网络变得日益壮大和复杂。应对这些挑战，
            首先要从管理您的 IP 地址清单以及重要的 DHCP 和 DNS 资源入手。MonitorWay IP 地址管理&终端用户追踪系统可以为您提供集中的 IP 地址管理，它与统一的 DHCP 和 DNS 管理相辅相成。
            这意味着运维人员可以快速地找出可用地址，并轻松地将其配置到几乎任何 DHCP 和 DNS 系统上。IPAM 还会就严重问题提前向您发出警报，例如地址冲突、DHCP/DNS 服务器性能不佳，
            或 DHCP 作用域中 IP 地址耗尽。</p>
          <img src="../../assets/monitor/ip.jpg" class="c-cs-p" preview="monitor-ip"/>
        </section>
        <section>
          <div class="c-d-f c-ai-c c-mt-84">
            <img src="../../assets/index/icon.png">
            <span class="c-ml-12 c-fs-24">MonitorWay IP地址管理&终端用户追踪系统概览</span>
          </div>
          <div class="c-bc-white c-fs-14 c-c-text-grey c-lh-36 c-mt-40 c-pt-56 c-pl-92 c-pb-64 c-p-r">
            <ul>
              <li>借助强大的 IPv4 和 IPv6 地址管理功能，防止 IP 冲突</li>
              <li>通过监控关键 IP 事件和接收相关警报，避免出现问题</li>
              <li>使用基于角色的访问将 IP 管理任务委派给机构和部门，实现多级管理</li>
              <li>与 MonitorWay 资产管理无缝集成，可快速定位当前的 IP 与主机、网络端口的关联关系</li>
            </ul>
            <img src="../../assets/monitor/ip-pic.png" class="c-pr-40 pic">
          </div>
        </section>
        <section class="c-pb-164 features">
          <div class="c-d-f c-ai-c c-mt-80">
            <img src="../../assets/index/icon.png">
            <span class="c-ml-12 c-fs-24">功能介绍</span>
          </div>
          <div class="c-d-f c-jc-sb c-fw-w c-mt-40 features-wrap">
            <div class="c-d-f c-jc-sb c-ai-fs c-bc-white features-item">
              <img src="../../assets/monitor/internet8.png">
              <div class="c-ml-40">
                <p class="c-mb-12 c-fs-20 c-c-text-blue">IPv4 和 IPv6 地址管理</p>
                <p class="c-ta-j c-fs-14 c-lh-28 c-c-text-grey">随着信息化的高速发展，用户对更高性能、BYOD、服务器虚拟化、云迁移以及智能设备的需求不断增加，
                  网络变得日益壮大和复杂。应对这些挑战， 首先要从管理您的 IP 地址资源入手。MonitorWay IP地址管理&终端用户追踪系统可以为您提供集中的 IP 地址管理。
                  这意味着运维人员可以快速地找出可用地址，并快速发现 IP 地址的分配与在线情况。IPAM 还会就严重问题提前向您发出警报，例如地址冲突、IP 地址段耗尽等。</p>
              </div>
            </div>
            <div class="c-d-f c-jc-sb c-ai-fs c-bc-white features-item">
              <img src="../../assets/monitor/ip2.png">
              <div class="c-ml-40">
                <p class="c-mb-12 c-fs-20 c-c-text-blue">详细的事件记录</p>
                <p class="c-ta-j c-fs-14 c-lh-28 c-c-text-grey">IPAM 可以自动记录所有 IP 事件，并保存详细的活动日志，显示更改内容及时间，以便快速轻松地排除故障。
                  通过使用这些详细活动日志来追溯导致 IP 冲突和其他 IP 相关问题的事件，您可以大幅减少故障排除时间。</p>
              </div>
            </div>
            <div class="c-d-f c-jc-sb c-ai-fs c-bc-white features-item">
              <img src="../../assets/monitor/ip4.png">
              <div class="c-ml-40">
                <p class="c-mb-12 c-fs-20 c-c-text-blue">监控和警报</p>
                <p class="c-ta-j c-fs-14 c-lh-28 c-c-text-grey">IPAM 能够自发地自动检测可能导致网络中断的 IP 地址问题。通过主动检测 IP 地址问题、通知网络中的 IP 地址更改，
                  以及访问重要指标的使用率数据以进行计划，您可以持续监控和提高 IP 性能。主动监控和警报可帮助消除 IP 冲突导致的网络停机问题和子网中 IP 地址耗尽导致的 IP 地址不可用问题。
                </p>
              </div>
            </div>
            <div class="c-d-f c-jc-sb c-ai-fs c-bc-white features-item">
              <img src="../../assets/monitor/internet5.png">
              <div class="c-ml-40">
                <p class="c-mb-12 c-fs-20 c-c-text-blue">基于机构和角色的管理</p>
                <p class="c-ta-j c-fs-14 c-lh-28 c-c-text-grey">IPAM 让您能够独立地管理您的 DHCP、DNS 和 IP 子网。使用 IPAM 可独立于其他管理员团队工作，这让每个团队都能管理其自己的子网、
                  地址块以及 DHCP 和 DNS 服务，而不会互相影响。基于机构和角色的管理可帮助维护安全性，且不会限制 IP 地址管理活动的委派。</p>
              </div>
            </div>
            <div class="c-d-f c-jc-sb c-ai-fs c-bc-white features-item">
              <img src="../../assets/monitor/ip6.png">
              <div class="c-ml-40">
                <p class="c-mb-12 c-fs-20 c-c-text-blue">IP 冲突检测资源</p>
                <p class="c-ta-j c-fs-14 c-lh-28 c-c-text-grey">快速处理 IP 冲突问题，避免网络停机。只要网络中存在 IP 冲突，IPAM 就会向您发出警报。
                  可展示设备详细信息以及帮助进行故障排除的交换机端口的信息。IP 地址使用率历史数据可揭示哪个设备最先拥有该 IP。</p>
              </div>
            </div>
            <div class="c-d-f c-jc-sb c-ai-fs c-bc-white features-item">
              <img src="../../assets/monitor/ip7.png">
              <div class="c-ml-40">
                <p class="c-mb-12 c-fs-20 c-c-text-blue">全局 IP 地址检索</p>
                <p class="c-ta-j c-fs-14 c-lh-28 c-c-text-grey">通过执行全局搜索，IPAM 可以在短短几秒钟内追踪到网络中的特定 IP 地址。您可以快速轻松地访问IP 地址数据，以搜索可用 IP 并满足 IP 请求。</p>
              </div>
            </div>
            <div class="c-d-f c-jc-sb c-ai-fs c-bc-white features-item">
              <img src="../../assets/monitor/ip8.png">
              <div class="c-ml-40">
                <p class="c-mb-12 c-fs-20 c-c-text-blue">子网分配向导</p>
                <p class="c-ta-j c-fs-14 c-lh-28 c-c-text-grey">您可以指定超网和子网的大小，以便 IPAM 能够自动分配大小合适的子网。子网分配向导可帮助您高效地根据适合网络范围和流量的小大，
                  将受管 IP 地址空间分组为子网。借助其实时子网计算器，IPAM 子网分配向导让您能够快速确定用于细分任意子网的科学方法。</p>
              </div>
            </div>
            <div class="c-d-f c-jc-sb c-ai-fs c-bc-white features-item">
              <img src="../../assets/monitor/internet7.png">
              <div class="c-ml-40">
                <p class="c-mb-12 c-fs-20 c-c-text-blue">自动发现 IPv4/IPv6 子网</p>
                <p class="c-ta-j c-fs-14 c-lh-28 c-c-text-grey">IPAM 通过直接从路由器配置和连接的机器中拉取数据，帮助您创建网络的最新 IP 地址地图。自动子网发现使用 SNMP 凭据来轮询设备，可发现来自路由器的路由表中的子网。</p>
              </div>
            </div>
            <div class="c-d-f c-jc-sb c-ai-fs c-bc-white features-item">
              <img src="../../assets/monitor/ip11.png">
              <div class="c-ml-40">
                <p class="c-mb-12 c-fs-20 c-c-text-blue">自动扫描 IP 地址</p>
                <p class="c-ta-j c-fs-14 c-lh-28 c-c-text-grey">IPAM 让您能够轻松地为 IPv4 和 IPv6 地址空间设置自动计划扫描。在减少人工错误的同时实现网络的IP 地址信息始终为最新。
                  IP 地址计划扫描还可通过识别瞬态 IP 状态来帮助避免 IP 地址冲突。</p>
              </div>
            </div>
          </div>
        </section>
      </section>
    </section>
    <section class="c-visible-mobile" v-if="!$store.state.isPc">
      <section class="cm-width monitor-wrap-mobile">
        <section class="c-mt-40 monitor-title">
          <p class="c-fs-19 c-fw-b c-c-text-color-dark">IP地址管理&终端用户追踪系统</p>
          <p class="c-fs-12 c-mt-16 c-mb-24 c-lh-22 c-ta-j">随着人们对更高性能、BYOD、服务器虚拟化、云迁移以及智能设备的需求不断增加，网络变得日益壮大和复杂。应对这些挑战，
            首先要从管理您的 IP 地址清单以及重要的 DHCP 和 DNS 资源入手。MonitorWay IP 地址管理&终端用户追踪系统可以为您提供集中的 IP 地址管理，它与统一的 DHCP 和 DNS 管理相辅相成。
            这意味着运维人员可以快速地找出可用地址，并轻松地将其配置到几乎任何 DHCP 和 DNS 系统上。IPAM 还会就严重问题提前向您发出警报，例如地址冲突、DHCP/DNS 服务器性能不佳，
            或 DHCP 作用域中 IP 地址耗尽。</p>
          <img src="../../assets/monitor/ip.jpg" preview="monitor-ip1"/>
        </section>
        <section>
          <div class="c-d-f c-ai-c c-mt-40">
            <img class="c-icon-mobile" src="../../assets/index/icon.png">
            <span class="c-ml-8 c-fs-16">MonitorWay IP地址管理&终端用户追踪系统概览</span>
          </div>
          <div class="c-bc-white c-fs-13 c-c-text-grey c-lh-28 c-mt-24 c-ptb-20 c-pl-36 c-pr-16 c-boxshadow">
            <ul>
              <li>借助强大的 IPv4 和 IPv6 地址管理功能，防止IP冲突</li>
              <li>通过监控关键 IP 事件和接收相关警报，避免出现问题</li>
              <li>使用基于角色的访问将IP管理任务委派给机构和部门，实现多级管理</li>
              <li>与 MonitorWay资产管理无缝集成，可快速定位当前的IP与主机、网络端口的关联关系。</li>
            </ul>
          </div>
        </section>
        <section class="features">
          <div class="c-d-f c-ai-c c-mt-40">
            <img class="c-icon-mobile" src="../../assets/index/icon.png">
            <span class="c-ml-8 c-fs-16">功能介绍</span>
          </div>
          <div class="c-mt-24 features-wrap">
            <swiper class="swiper" :options="swiperOption" ref="mySwiper">
              <swiper-slide>
                <div class="c-mb-8 features-item">
                  <div class="c-bc-white c-d-f c-pe-none">
                    <img src="../../assets/monitor/internet8.png">
                    <div class="c-ml-24">
                      <p class="c-fs-15 c-c-text-blue c-mb-8">IPv4 和 IPv6 地址管理</p>
                      <p class="c-fs-12 c-lh-20 c-c-text-grey">随着信息化的高速发展，用户对更高性能、BYOD、服务器虚拟化、云迁移以及智能设备的需求不断增加，
                        网络变得日益壮大和复杂。应对这些挑战， 首先要从管理您的 IP 地址资源入手。MonitorWay IP 地址管理&终端用户追踪系统可以为您提供集中的 IP 地址管理。
                        这意味着运维人员可以快速地找出可用地址，并快速发现 IP 地址的分配与在线情况。IPAM 还会就严重问题提前向您发出警报，例如地址冲突、IP 地址段耗尽等。</p>
                    </div>
                  </div>
                </div>
                <div class="c-mb-8 features-item">
                  <div class="c-bc-white c-d-f c-pe-none">
                    <img src="../../assets/monitor/ip2.png">
                    <div class="c-ml-24">
                      <p class="c-fs-15 c-c-text-blue c-mb-8">详细的事件记录</p>
                      <p class="c-fs-12 c-lh-20 c-c-text-grey">IPAM 可以自动记录所有 IP 事件，并保存详细的活动日志，显示更改内容及时间，以便快速轻松地排除故障。
                        通过使用这些详细活动日志来追溯导致 IP 冲突和其他 IP 相关问题的事件，您可以大幅减少故障排除时间。</p>
                    </div>
                  </div>
                </div>
                <div class="c-mb-8 features-item">
                  <div class="c-bc-white c-d-f c-pe-none">
                    <img src="../../assets/monitor/internet7.png">
                    <div class="c-ml-24">
                      <p class="c-fs-15 c-c-text-blue c-mb-8">子网分配向导</p>
                      <p class="c-fs-12 c-lh-20 c-c-text-grey">您可以指定超网和子网的大小，以便 IPAM 能够自动分配大小合适的子网。子网分配向导可帮助您高效地根据适合网络范围和流量的小大，
                        将受管 IP 地址空间分组为子网。借助其实时子网计算器，IPAM 子网分配向导让您能够快速确定用于细分任意子网的科学方法。</p>
                    </div>
                  </div>
                </div>
                <div class="c-mb-44 features-item">
                  <div class="c-bc-white c-d-f c-pe-none">
                    <img src="../../assets/monitor/ip11.png">
                    <div class="c-ml-24">
                      <p class="c-fs-15 c-c-text-blue c-mb-8">自动扫描 IP 地址</p>
                      <p class="c-fs-12 c-lh-20 c-c-text-grey">IPAM 让您能够轻松地为 IPv4 和 IPv6 地址空间设置自动计划扫描。在减少人工错误的同时实现网络的IP 地址信息始终为最新。
                        IP 地址计划扫描还可通过识别瞬态 IP 状态来帮助避免 IP 地址冲突。</p>
                    </div>
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="c-mb-8 features-item">
                  <div class="c-bc-white c-d-f c-pe-none">
                    <img src="../../assets/monitor/internet5.png">
                    <div class="c-ml-24">
                      <p class="c-fs-15 c-c-text-blue c-mb-8">基于机构和角色的管理</p>
                      <p class="c-fs-12 c-lh-20 c-c-text-grey">IPAM 让您能够独立地管理您的 DHCP、DNS 和 IP 子网。使用 IPAM 可独立于其他管理员团队工作，这让每个团队都能管理其自己的子网、
                        地址块以及 DHCP 和 DNS 服务，而不会互相影响。基于机构和角色的管理可帮助维护安全性，且不会限制 IP 地址管理活动的委派。</p>
                    </div>
                  </div>
                </div>
                <div class="c-mb-8 features-item">
                  <div class="c-bc-white c-d-f c-pe-none">
                    <img src="../../assets/monitor/ip6.png">
                    <div class="c-ml-24">
                      <p class="c-fs-15 c-c-text-blue c-mb-8">IP 冲突检测资源</p>
                      <p class="c-fs-12 c-lh-20 c-c-text-grey">快速处理 IP 冲突问题，避免网络停机。只要网络中存在 IP 冲突，IPAM 就会向您发出警报。
                        可展示设备详细信息以及帮助进行故障排除的交换机端口的信息。IP 地址使用率历史数据可揭示哪个设备最先拥有该 IP。</p>
                    </div>
                  </div>
                </div>
                <div class="c-mb-8 features-item">
                  <div class="c-bc-white c-d-f c-pe-none">
                    <img src="../../assets/monitor/ip7.png">
                    <div class="c-ml-24">
                      <p class="c-fs-15 c-c-text-blue c-mb-8">全局 IP 地址检索</p>
                      <p class="c-fs-12 c-lh-20 c-c-text-grey">通过执行全局搜索，IPAM 可以在短短几秒钟内追踪到网络中的特定 IP 地址。您可以快速轻松地访问IP 地址数据，以搜索可用 IP 并满足 IP 请求。</p>
                    </div>
                  </div>
                </div>
                <div class="c-mb-44 features-item">
                  <div class="c-bc-white c-d-f c-pe-none">
                    <img src="../../assets/monitor/ip8.png">
                    <div class="c-ml-24">
                      <p class="c-fs-15 c-c-text-blue c-mb-8">监控和警报</p>
                      <p class="c-fs-12 c-lh-20 c-c-text-grey">IPAM 能够自发地自动检测可能导致网络中断的 IP 地址问题。通过主动检测 IP 地址问题、通知网络中的 IP 地址更改，
                        以及访问重要指标的使用率数据以进行计划，您可以持续监控和提高 IP 性能。主动监控和警报可帮助消除 IP 冲突导致的网络停机问题和子网中 IP 地址耗尽导致的 IP 地址不可用问题。</p>
                    </div>
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="c-mb-44 features-item">
                  <div class="c-bc-white c-d-f c-pe-none">
                    <img src="../../assets/monitor/ip4.png">
                    <div class="c-ml-24">
                      <p class="c-fs-15 c-c-text-blue c-mb-8">自动发现 IPv4/IPv6 子网</p>
                      <p class="c-fs-12 c-lh-20 c-c-text-grey">IPAM 通过直接从路由器配置和连接的机器中拉取数据，帮助您创建网络的最新 IP 地址地图。自动子网发现使用 SNMP 凭据来轮询设备，可发现来自路由器的路由表中的子网。</p>
                    </div>
                  </div>
                </div>
              </swiper-slide>
              <div class="swiper-pagination" id="swiper-pagination1" slot="pagination"></div>
            </swiper>
          </div>
        </section>
      </section>
    </section>
  </section>
</template>

<script>
export default {
  name: 'ip',
  data () {
    return {
      swiperOption: {
        ...this.$store.state.swiperOptions,
        pagination: {
          el: '#swiper-pagination1',
          clickable: true
        }
      }
    }
  }
}
</script>

<style lang="scss">
.p-ipmonitor {
  @media screen and (min-width: 1180px) {
    min-height: calc(100vh - 90px - 525px);
    background: url('../../assets/monitor/monitor-bg.png') no-repeat;
    background-position: bottom;
    background-size: 100%;
  }
  .monitor-wrap {
    width: 1180px;
    margin: 0 auto;
    .monitor-title {
      img {
        height: 417px;
      }
    }
    .pic {
      position: absolute;
      right: 0;
      top: -80px;
    }
    .features {
      .features-wrap {
        .features-item {
          width: calc(50% - 7px);
          padding: 44px 54px;
          margin-bottom: 14px;
          box-shadow: 0 8px 34px 0 rgba(0, 31, 255, 0.05);
          border-radius: 1px;
          img {
            width: 18%;
          }
        }
        .features-special {
          width: 100%;
          img {
            width: 10%;
          }
        }
      }
    }
  }
  .monitor-wrap-mobile {
    .monitor-title {
      img {
        // height: 202px;
        width: 100%;
      }
    }
    .features {
      .features-wrap {
        padding-bottom: 25px;
        .features-item {
          width: 100%;
          padding: 25px 16px;
          background: white;
          text-align: justify;
          img {
            width: 38px;
            height: 38px;
            object-fit: contain;
          }
        }
      }
    }
    .swiper {
      width: 100%;
      --swiper-theme-color: #FF8243;
      .swiper-pagination, .swiper-pagination-bullets {
        bottom: 15px;
        .swiper-pagination-bullet {
          width: 20px;
          height: 3px;
          border-radius: 1.5px;
          margin: 0 4px;
          outline: none;
        }
        .swiper-pagination-bullet-active {
          width: 50px;
        }
      }
    }
  }
}
</style>
